<template>
    <div class="c-picture-card-list">
        <el-row :gutter="10">
            <el-col v-for="(item, index) in data" :key="'pic-card_' + index" :md="24" :lg="12" :xl="8">
                <PictureCard
                    width="100%"
                    :url="item.url"
                    @click="handleClick(item)"
                    :cardType="cardType"
                    :bottomShowType="bottomShowType"
                    :topShowType="topShowType"
                >
                    <template slot="bottom">
                        <slot name="bottom" :data="item"></slot>
                    </template>
                    <template slot="top">
                        <slot name="top" :data="item"></slot>
                    </template>
                    <template>
                        <slot :data="item"></slot>
                    </template>
                </PictureCard>
            </el-col>
        </el-row>
        <!-- <PictureCard
            v-for="(item, index) in data"
            :key="'pic-card_' + index"
            :url="item.url"
            @click="handleClick(item)"
            :cardType="cardType"
            :bottomShowType="bottomShowType"
        >
            <template slot="bottom">
                <slot name="bottom" :data="item"></slot>
            </template>
            <template>
                <slot :data="item"></slot>
            </template>
        </PictureCard> -->
    </div>
</template>

<script>
import PictureCard from './PictureCard.vue';

export default {
    components: {
        PictureCard,
    },
    props: {
        data: {
            // 图册数据
            type: Array,
            default() {
                return [];
            },
        },
        cardType: {
            // 卡片类型
            type: String, // atlas :图集,picture：图片
            default: 'atlas',
        },
        bottomShowType: {
            // bottom 显示方式,当showBottom为true时有效，hover:鼠标hover时显示,always:一直显示
            type: String,
            validator(val) {
                return ['hover', 'always'].indexOf(val) !== -1;
            },
            default() {
                return 'hover';
            },
        },
        topShowType: {
            // top 显示方式,当showTop为true时有效，hover:鼠标hover时显示,always:一直显示
            type: String,
            validator(val) {
                return ['hover', 'always'].indexOf(val) !== -1;
            },
            default() {
                return 'hover';
            },
        },
    },
    data() {
        return {};
    },
    methods: {
        handleClick(data) {
            this.$emit('pic-card-click', data);
        },
    },
};
</script>

<style lang="scss" scoped>
.c-picture-card-list {
}
</style>
